import { CloudMeshbotActionTypes } from '../constants/ActionTypes/CloudMeshbot';

/**
 * Creates a Redux action to set the cloud MeshBot scene loading state.
 *
 * @param {boolean} isLoading - `true` to indicate loading in progress, `false` when done.
 * @returns {{ type: string, isLoading: boolean }} Redux action object.
 *
 * @example
 * dispatch(setSceneProgress(true));
 * // ... async work ...
 * dispatch(setSceneProgress(false));
 */
export const setSceneProgress = (isLoading) => ({
    type: CloudMeshbotActionTypes.CLOUD_SCENE_SET_LOADING,
    isLoading,
});
